import axios from "axios";
import {EnvironmentRegistry} from "./registry/environmentRegistry";
import {AuthContextType, queryExecutorRequestBody, queryExecutorResponse} from "../types/types";


export async function executeQuery(requestBody:queryExecutorRequestBody,authContext: AuthContextType): Promise<queryExecutorResponse> {

    const response  = await axios.post<queryExecutorRequestBody,queryExecutorResponse>(`https://kpi.sellina.io/v1/kpi/query/execute?env=${authContext.env}`, requestBody, {
        headers: EnvironmentRegistry.makeAuthHeadersFromContext(authContext)
    })
    return response;

}

export async function executeScript(requestBody:queryExecutorRequestBody,authContext: AuthContextType): Promise<queryExecutorResponse> {

    const response  = await axios.post<queryExecutorRequestBody,queryExecutorResponse>(`https://kpi.sellina.io/v1/kpi/query/execute/script?env=${authContext.env}`, requestBody, {
        headers: EnvironmentRegistry.makeAuthHeadersFromContext(authContext)
    })
    return response;

}
